import { WebPlugin } from '@capacitor/core';
export class TestFlightDetectWeb extends WebPlugin {
    async checkTF() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map